import { formateNumber } from '../../utils/date-utils/formatters';

export const Calculation = ({
  title,
  counter,
  classes = '',
  headerClasses = 'font-medium',
}: {
  title: string;
  counter: number;
  classes?: string;
  headerClasses?: string;
}) => {
  return (
    <div>
      <div className={`${headerClasses} text-base md:text-s-14`}>{title}</div>
      <div
        className={`${
          classes.includes('font-bold') ? 'font-bold' : 'font-medium'
        } text-s-24 sm:text-s-24 md:text-base pt-3 ${classes}`}
      >
        {'₹' + formateNumber(counter)}
      </div>
    </div>
  );
};
